import React from "react";
import {Card, Form, Input} from "reactstrap";
import {FaTrash} from "react-icons/fa";
import {useDispatch, useSelector} from "react-redux";
import {storeReportSelectedControllerList} from "../../../redux/Actions/reports.actions";
import {
  getSelectedControllerList,
  getCreateReportData,
} from "../../../redux/Selectors/reports.selectors";

const AddComment = () => {
  const dispatch = useDispatch();
  const controllerList = useSelector(getSelectedControllerList);
  const createReportData = useSelector(getCreateReportData);
  const {status} = createReportData;

  const handleCommentChange = (value, commentIndex, controllerIndex) => {
    let list = [...controllerList];
    let currentController = list[controllerIndex];
    let comments = [...currentController.comments];
    comments[commentIndex] = value;
    currentController = {
      ...currentController,
      comments,
    };
    list[controllerIndex] = currentController;
    dispatch(storeReportSelectedControllerList(list));
  };

  const deleteComment = (commentIndex, controllerIndex) => {
    if (status === "under-review" || status === "submitted") {
      return;
    }
    let list = [...controllerList];
    let currentController = list[controllerIndex];
    let comments = [...currentController.comments];
    comments.splice(commentIndex, 1);
    currentController = {
      ...currentController,
      comments,
    };
    list[controllerIndex] = currentController;
    dispatch(storeReportSelectedControllerList(list));
  };

  return (
    <Card
      style={{
        padding: "1rem",
        boxShadow: "0px 3px 6px #00000029",
        position: "relative",
      }}
    >
      <div
        className="roboto-bold"
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          borderBottom: "1px solid #20C1FF",
          marginBottom: "1rem",
          color: "#303030",
          paddingBottom: "5px",
        }}
      >
        Add Comments{" "}
      </div>
      {controllerList &&
        controllerList.map((controller, controllerIndex) => {
          const {name, comments} = controller;
          return (
            <div key={controllerIndex}>
              {comments && comments.length > 0 && (
                <div style={{marginBottom: "1rem"}}>
                  <div
                    style={{color: "#303030", fontWeight: "bold", marginBottom: "0.5rem"}}
                    className="roboto-bold"
                  >
                    {name}
                  </div>
                  {comments.map((comment, commentIndex) => {
                    return (
                      <Form key={commentIndex} style={{marginBottom: "0.5rem"}}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            paddingBottom: "0.5rem",
                          }}
                        >
                          <FaTrash
                            onClick={() => deleteComment(commentIndex, controllerIndex)}
                            style={{
                              cursor:
                                status === "under-review" || status === "submitted"
                                  ? ""
                                  : "pointer",
                            }}
                            data-cy="deleteComment"
                          />
                        </div>
                        <Input
                          type="textarea"
                          placeholder="My comments on the report"
                          className="comment-box"
                          value={comment}
                          onChange={(e) =>
                            handleCommentChange(
                              e.target.value,
                              commentIndex,
                              controllerIndex
                            )
                          }
                          disabled={status === "under-review" || status === "submitted"}
                          data-cy="commentInput"
                        />
                      </Form>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
    </Card>
  );
};

export default AddComment;
